export default {
  REDEEM: 'REDEEM',
  REWARD: 'REWARD',
  REWARD_DIRECT_INCENTIVE: 'REWARD_DIRECT_INCENTIVE',
  REDEEM_DIRECT_INCENTIVE: 'REDEEM_DIRECT_INCENTIVE',
}
